/* eslint-disable @typescript-eslint/no-unused-vars */
import { CommonTable } from "../common/common-list/table/Table";
import { KTCard } from "../../../../_metronic/helpers";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Pagination } from "../common/common-list/components/pagination/Pagination";
import { setId, setSort } from "../../../../redux/features/shared/sharedSlice";
import { CompanyModal } from "./CompanyModal";
import './style.scss';
import { UserListHeader } from "../common/common-list/components/header/UserListHeader";
import { getServices } from "../../../../redux/features/service/_serviceAction";
import { servicesColumns } from "../common/common-list/table/columns/_serviceColumns";
import { getCompanies } from "../../../../redux/features/company/_companyAction";
import { companyColumns } from "../common/common-list/table/columns/_companyColumns";
import { AdditionalEmailModal } from "./AdditionalEmails";

const CompaniesList = () => {
  const sharedActions = useSelector((state: any) => state.sharedActions);
  const dispatch: any = useDispatch();
  const data: any = useSelector((state: any) => state.companyList?.data)||[];
  const totalRecord  = useSelector((state: any) => state.companyList?.totalRecord);

  useEffect(() => {
    dispatch(setId('Company'))
    dispatch(getCompanies({ page: 1, limit: 10, sortOrder: sharedActions.sort }));
  }, [dispatch, sharedActions.sort]);

  const handleClick = (page: number) => {
    dispatch(getCompanies({ page: page, limit: 10, sortOrder: sharedActions.sort }));
  };


  return (
    <>
      <KTCard>
        <UserListHeader />
        <CommonTable data={data} columns={companyColumns} />
        {sharedActions.companyModal && <CompanyModal />}
        {sharedActions.additionalEmails && <AdditionalEmailModal />}
        {totalRecord > 10 && <Pagination
          totalRecord={totalRecord}
          handleClick={handleClick}
        />}
      </KTCard>
    </>
  );
};

export { CompaniesList };
